
































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import { ConsultController, DropDownController } from '@/services/request.service';
import { DropDownResponse } from '@/services/__model';
import { getSchoolInfo } from '@/utils/utils';
import MainInfo from './MainInfo.vue';
import config from '@/school.config';
import moment, { Moment } from 'moment';

@Component({
  components: {
    MainInfo,
  },
})
export default class ActivityDetail extends Vue {
  @Prop({ default: () => {} }) public data!: any;
  public visitList: Array<DropDownResponse> = [];
  public activityStatus: string = '';
  public activityVisitIds: Array<any> = [];
  public visitTime: Moment | null = null;
  public visibleOfBindActivity: boolean = false;
  public operatedColumn: any = [];
  public sectionId = '';
  public moment = moment;
  public config = config;

  public created() {
    this.$store.dispatch('getJoinStatusList');
  }

  // @Watch('data', { immediate: true })
  // public getOperatedColumn(newVal: any) {
  //   this.operatedColumn = [{ consultMasterId: this.$route.query.id, student: newVal.name }];
  // }

  public get locale(): string {
    return this.$i18n.locale;
  }

  public get schoolId(): string {
    return getSchoolInfo().schoolId.toString();
  }

  // public changeDefaultStatus(item: any): void {
  //   this.activityStatus = item.joinStatus !== '0000' ? item.joinStatus : '3201';
  // }

  // public changeVisitTime(item: any) {
  //   if (item.visitTimeFlag && item.visitTimeBySectionFlag && item.sectionId) {
  //     this.getVisitList(item.activityChannelId, item.sectionId);
  //   } else if (item.visitTimeFlag && !item.visitTimeBySectionFlag) {
  //     this.getVisitList(item.activityChannelId, undefined);
  //   }
  // }

  // public getVisitList(activityChannelId: any, sectionId?: any) {
  //   DropDownController.getActivityVisitList(activityChannelId, sectionId).then(res => {
  //     this.visitList = res.data;
  //   });
  // }

  // public handleStatusChange(item: any): void {
  //   if (!this.activityStatus) {
  //     this.$message.error(this.$tc('checkStatus'));
  //     return;
  //   }
  //   ConsultController.updateConsultJoinStatus(item.consultId, this.activityStatus).then(res => {
  //     this.$emit('getEnquiryDetail');
  //     this.$message.success(this.$tc('changeSuccess'));
  //     this.activityStatus = '';
  //   });
  // }

  // public updateConsultVisitTime(item: any) {
  //   const request: any = {
  //     consultId: item.consultId,
  //   };
  //   if (item.visitTimeBySectionFlag && this.sectionId) {
  //     request.sectionId = this.sectionId;
  //   }
  //   if (item.visitTimeFlag) {
  //     request.activityVisitIds = this.activityVisitIds;
  //   } else {
  //     request.visitTime = moment(this.visitTime).valueOf();
  //   }
  //   ConsultController.updateConsultVisitTime(request).then(() => {
  //     this.$emit('getEnquiryDetail');
  //     this.$message.success(this.$tc('changeSuccess'));
  //     this.activityVisitIds = [];
  //     this.visitTime = null;
  //   });
  // }
}
